import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      backgroundColor: '#fff',
      borderRadius: '4px',
      margin: '32px',
      width: '90%',
      maxWidth: '1200px',
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: 'none',
    position: 'relative',
    minHeight: '60px',
  },
  title: {
    fontWeight: 600,
    fontSize: '24px',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    color: '#000',
    margin: 0,
    width: '100%',
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    cursor: 'pointer',
    zIndex: 10,
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '&:hover': {
      opacity: 0.7,
    },
  },
  closeText: {
    fontSize: '14px',
    color: '#000',
  },
  closeIcon: {
    color: '#FF0000',
    fontSize: '28px',
  },
  dialogContent: {
    padding: '32px 24px 24px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowX: 'hidden',
  },
  tableContainer: {
    width: '100%',
    maxWidth: '100%',
    marginBottom: '32px',
    border: '1px solid #E0E0E0',
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    tableLayout: 'auto',
  },
  headerCell: {
    backgroundColor: '#F9F9FC',
    fontWeight: 700,
    padding: '8px 16px',
    fontSize: '14px',
    borderBottom: '1px solid #E0E0E0',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    verticalAlign: 'middle',
  },
  tableCell: {
    padding: '8px 16px',
    fontSize: '14px',
    verticalAlign: 'middle',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  },
  multiLineCell: {
    lineHeight: '1.5',
  },
}));

